import { lowerCase, startCase } from 'lodash';

const COMMON_ACRONYMS = [
  'LLC',
  'LP',
  'LLP',
  'PC',
  'PA',
  'PLLC',
  'IRA',
  '401K',
  'SEP',
  'ROTH',
  'HSA',
  'MSA',
  'FSA',
  'GST',
];

/**
 * Converts text to sentence case while preserving common acronyms.
 * This is useful for entity names that come back in all caps but contain
 * acronyms that should remain uppercase (e.g., "SMITH FAMILY LLC" -> "Smith Family LLC").
 */
export function sentenceCaseWithAcronyms(text: string): string {
  if (!text) return text;

  // Trim whitespace and normalize spaces/tabs
  const normalizedText = text.trim().replace(/\s+/g, ' ');

  // Split the text into words
  const words = normalizedText.toLowerCase().split(' ');

  // Process each word
  const processedWords = words.map((word) => {
    // Remove punctuation for acronym checking but preserve it for display
    const cleanWord = word.replace(/[^\w]/g, '');

    // Check if the clean word is a known acronym
    if (COMMON_ACRONYMS.includes(cleanWord.toUpperCase())) {
      // Replace the clean part with uppercase while preserving punctuation
      return word.replace(cleanWord, cleanWord.toUpperCase());
    }

    // Otherwise, capitalize first letter only
    return word.charAt(0).toUpperCase() + word.slice(1);
  });

  return processedWords.join(' ');
}

/**
 * Legacy function that uses lodash's startCase and lowerCase.
 * Use sentenceCaseWithAcronyms for better acronym handling.
 */
export function basicSentenceCase(text: string): string {
  return startCase(lowerCase(text));
}
